export enum UserRoleE {
  AGENT = 'agente',
  SUPERVISOR = 'supervisor',
  ADMNISTRATOR = 'administrador',
  ADMNISTRATOR_MASTER = 'administrador-master',
}
